export default __webpack_public_path__ + "static/media/loading.d290eee5.gif";